import './projectCard.scss';
import * as React from 'react';
import { icons } from '../../content/icons';
import { RoutePaths } from '../../routes';
import { ImageUtils } from '../../utils/image';
import { Card } from '../layout/card';
import { RMButton } from '../layout/rmButton';
import { LazyCosmosImage } from '../media/cosmosImage';
import ProjectTags from './projectTags';
export const ProjectCard = ({ project }) => (<Card className="project-card" style={{ ['--client-colour']: project.client_brand_color }} to={RoutePaths.projects.project(project)}>
    <LazyCosmosImage className="project-mockup" ticket={project.project_transparent_bg_mockup?.[0]?.ticket} alt="Projects " size={ImageUtils.imageSizes.small}/>
    <h3>{project.client_name}</h3>
    <p className="description">{project.project_description_short}</p>

    <ProjectTags tags={project.project_types}/>

    <RMButton variant="lighten-bg" rightIcon={icons.right}>
      More info
    </RMButton>
  </Card>);
